import { IUsersGetResponse } from "@edgetier/watchtower-types";
import { IUserFormValues } from "components-for/users/user-form";

/**
 * Update the react query cache with the updated user details.
 * @param user        The user with updated values.
 * @param cachedUsers The users in the cache.
 * @returns An updated object containing the new user's information.
 */
export const updateUsersCache = (user: IUserFormValues & { userId: string }) => (
    cachedUsers: IUsersGetResponse | undefined
) => {
    const pagination = cachedUsers?.pagination ?? { nextPage: null, previousPage: null };
    const newUsers = (cachedUsers?.items ?? []).map((queryUser) =>
        user.userId === queryUser.userId ? { ...queryUser, ...user } : queryUser
    );
    return {
        pagination,
        items: newUsers,
    };
};
